
import React, { useEffect, useState, Children, useContext } from 'react'
import { GlobalContext } from '../GlobalContext'
import { Link, useSearchParams } from "react-router-dom"
import Button from '../formfields/Button'

type Props = {
    children: any
    setDisplayItems: React.Dispatch<React.SetStateAction<any>>
    arrayToPageThrough: any[]
    itemsPerPage: number
}


function Paginate({
    children,
    setDisplayItems,
    arrayToPageThrough,
    itemsPerPage = 5
}: Props) {


    const [searchParams] = useSearchParams()
    const [page, setPage] = useState(1)
    const lengthOfArray = arrayToPageThrough.length
    const numberOfPages = Math.ceil(lengthOfArray / itemsPerPage)
    const pageNumbers = Array.from({ length: numberOfPages }, (_, i) => i + 1)


    useEffect(() => {
        setPage(1) // Reset to first page when search params change
    }, [searchParams])

    useEffect(() => {
        const indexOfLastItem = page * itemsPerPage
        const indexOfFirstItem = indexOfLastItem - itemsPerPage
        setDisplayItems({ indexOfFirstItem, indexOfLastItem })
    }, [page])


    return <div className={`w-full flex flex-col gap-2`}>

        {pageNumbers && pageNumbers.length > 1 && <div className={`w-full flex flex-row gap-1 justify-end`}>
            {pageNumbers.map((pageNumber) => {
                return <Button
                    key={pageNumber}
                    onClick={() => setPage(pageNumber)}
                    text={`${pageNumber}`}
                    variant={page === pageNumber ? 'gray' : 'primary'}
                    disabled={page === pageNumber ? true : false}
                    fullwidth={false}
                    size='small'
                />
            })}
        </div>}
        <div className={`w-full flex flex-col gap-2`}>
            {children}
        </div>
    </div>
}

export default Paginate